import React, {useEffect, useState} from 'react';
import s from './ListOfTransfers.module.css'
import {ConfigProvider, DatePicker, Dropdown, Space} from "antd";
import arrow from "../../../../assets/images/personalAccount/arrow.svg";
import arrow_right from "../../../../assets/images/mobile/chevron.svg";
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux";
import {
    ITransaction,
    setFilters,
    setTransactionTypeFilter
} from "../../../../store/reducers/TransactionsSlice/TransactionsSlice";
import {Formik} from "formik";
import dayjs from "dayjs";
import Table, {ColumnsType} from "antd/es/table";
import {ReactComponent as SortIconAsc} from "../../../../assets/images/personalAccount/sortArrow.svg";
import {ReactComponent as SortIconDesc} from "../../../../assets/images/personalAccount/sortArrowDown.svg";
import {ReactComponent as SortIcons} from "../../../../assets/images/personalAccount/sortIcons.svg";
import {toHumanDate} from "../../../../helpers/ConvertDate";
import TransparentButton from "../../../../components/ui/TransparentButton/TransparentButton";
import {useSelector} from "react-redux";
import {selectTransactionsByFilter} from "../../../../store/reducers/TransactionsSlice/selector";
import {useAccountsForSelect} from "../../../../hooks/useAccountsForSelect";
import {getStatementThunk, getTransactionsListThunk} from "../../../../store/reducers/ActionCreators";
import classnames from "classnames";
import CustomModal from "../../../../components/ui/CustomModal/CustomModal";
import {ReactComponent as Back} from '../../../../assets/images/personalAccount/back.svg'
import Icon from "@ant-design/icons";
import {TRANSACTION_TYPES, TRANSACTION_TYPE_LABELS} from "../../../../constants/TransactionTypeConstants";

// export interface DataType {
//     balance: number,
//     currency: string,
//     number: string,
//     status: string
// }

const columns: ColumnsType<any> = [
    {
        title: 'date',
        dataIndex: 'date',
        sorter: (a, b) => {
            return a.date.props["data-time"] - b.date.props["data-time"]
        },
        className: `${s.dateCell}`,
        sortIcon: (props: { sortOrder: any }) => {
            if (props.sortOrder === 'ascend') {
                return <SortIconAsc/>
            }
            if (props.sortOrder === 'descend') {
                return <SortIconDesc/>
            }
            return <SortIcons/>
        }
    },
    {
        title: 'transfer №',
        dataIndex: 'transferN',
    },
    {
        title: 'payer',
        dataIndex: 'payer',
    },
    {
        title: 'recipient',
        dataIndex: 'recipient',
    },
    {
        title: 'type',
        dataIndex: 'type',
    },
    {
        title: 'amount',
        dataIndex: 'amount',
        align: 'right',
        sorter: (a, b) => {
            return a.amount.props["data-amount"] - b.amount.props["data-amount"]
        },
        sortIcon: (props: { sortOrder: any }) => {
            if (props.sortOrder === 'ascend') {
                return <SortIconAsc/>
            }
            if (props.sortOrder === 'descend') {
                return <SortIconDesc/>
            }
            return <SortIcons/>
        },
        className: `${s.amountColumn}`
    },
    {
        title: 'status',
        dataIndex: 'status',
        align: 'right',
    },
    {
        title: 'action',
        dataIndex: 'action',
        align: 'center',
        width: 80,
    },
];

const getRecipientDisplay = (transaction: ITransaction): string => {
    if (transaction.recipient && transaction.recipient.trim() !== '') {
        return transaction.recipient;
    }
    
    if (transaction.recipientDetails) {
        if (transaction.recipientDetails.fullName) {
            return transaction.recipientDetails.fullName;
        }
        if (transaction.recipientDetails.firstName && transaction.recipientDetails.lastName) {
            return `${transaction.recipientDetails.firstName} ${transaction.recipientDetails.lastName}`;
        }
        if (transaction.recipientDetails.beneficiaryName) {
            return transaction.recipientDetails.beneficiaryName;
        }
        if (transaction.recipientDetails.recipientsAccountNumber) {
            return transaction.recipientDetails.recipientsAccountNumber;
        }
        if (transaction.recipientDetails.ibanCode) {
            return transaction.recipientDetails.ibanCode;
        }
    }
    
    return transaction.toAccount || 'N/A';
};

const ListOfTransfers = () => {

    const sortedTransactions = useSelector(selectTransactionsByFilter)
    const token = useAppSelector(state => state.userReducer.user.userToken)
    const [selectedType, setSelectedType] = useState<number | string>(TRANSACTION_TYPES.ALL);
    const [selectedAccount, setSelectedAccount] = useState('ALL');
    const [isMobile, setIsMobile] = useState(false)
    const [statementLink, setStatementLink] = useState('');
    const [statementLinkIsDisabled, setStatementLinkIsDisabled] = useState(false)
    const [date, setDate] = useState({
        from: '',
        to: ''
    })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedTransfer, setSelectedTransfer] = useState<any>();
    const accountsList = useAccountsForSelect()
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (token) {
            const currentFilters = {
                accountNumber: selectedAccount,
                from: date.from || '',
                to: date.to || '',
                selectedType: selectedType,
                purpose: '',
                recipient: '',
                amount: '',
                incoming: false,
                outgoing: false,
                currency: '',
                templateName: '',
                paymentRegion: '',
                period: null
            }
            dispatch(getTransactionsListThunk(token, currentFilters))
        }
    }, [token, dispatch])

    useEffect(() => {
        return () => {
            dispatch(setFilters({
                accountNumber: '',
                period: null,
                from: '',
                to: '',
                purpose: '',
                recipient: '',
                amount: '',
                incoming: false,
                outgoing: false,
                currency: '',
                selectedType: '',
                templateName: ''
            }))
        }
    }, [dispatch])

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }, [])



    useEffect(() => {
        dispatch(setTransactionTypeFilter(selectedType.toString()))
    }, [selectedType, dispatch])

    const getSelectedAccountDisplay = () => {
        const account = accountsList.find((acc: any) => acc.number === selectedAccount)
        if (!account) return 'ALL'
        return account.number === 'ALL' ? 'ALL' : `${account.number} ${account.balance} ${account.currency}`
    }

    const handleTypePicker = ({label, key}: any) => {
        setSelectedType(key)
    }

    const handleAccountPicker = ({label, key}: any) => {
        setSelectedAccount(key)
    }

    const dateStyle = {
        fontFamily: 'Inter',
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '18px',
        color: '#2A2E37',
        padding: '17px 16px',
        height: 55,
        width: isMobile ? "100%" : 146,
        border: '1.5px solid #EEEFEF',
        borderRadius: 8
    }

    const dateFormat = 'YYYY-MM-DD';

    const contentStyle = {
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '18px',
        color: '#979797'
    };

    const dropdownStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 17,
        width: isMobile ? '100%' : 316,
        height: 55,
        border: '1.5px solid #EEEFEF',
        borderColor: '#EEEFEF',
        borderRadius: 8,
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '18px',
        color: '#2A2E37',
        background: '#FFFFFF'
    }

    const menuStyle = {
        border: '1.5px solid #EEEFEF',
        borderRadius: 8,
    };

    const transactionTypesArray = [
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.ALL],
            key: TRANSACTION_TYPES.ALL,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.INTRA_TRANSACTION],
            key: TRANSACTION_TYPES.INTRA_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.INTERNATIONAL_TRANSACTION_SWIFT],
            key: TRANSACTION_TYPES.INTERNATIONAL_TRANSACTION_SWIFT,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.EXCHANGE_TRANSACTION],
            key: TRANSACTION_TYPES.EXCHANGE_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.ACH_TRANSACTION],
            key: TRANSACTION_TYPES.ACH_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.EFT_TRANSACTION],
            key: TRANSACTION_TYPES.EFT_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.EUROPE_TRANSACTION_SEPA],
            key: TRANSACTION_TYPES.EUROPE_TRANSACTION_SEPA,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.BACS_TRANSACTION],
            key: TRANSACTION_TYPES.BACS_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.DOMESTIC_WIRE_TRANSACTION],
            key: TRANSACTION_TYPES.DOMESTIC_WIRE_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.INTERNATIONAL_TRANSACTION_PAN_AFRICA],
            key: TRANSACTION_TYPES.INTERNATIONAL_TRANSACTION_PAN_AFRICA,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.CARD_TRANSACTION],
            key: TRANSACTION_TYPES.CARD_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.CRYPTO_TRANSACTION],
            key: TRANSACTION_TYPES.CRYPTO_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.INTERAC_TRANSACTION],
            key: TRANSACTION_TYPES.INTERAC_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.BILL_PAYMENT_TRANSACTION],
            key: TRANSACTION_TYPES.BILL_PAYMENT_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.EUROPE_TRANSACTION_SEPA_INSTANT],
            key: TRANSACTION_TYPES.EUROPE_TRANSACTION_SEPA_INSTANT,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.FASTER_PAYMENT_TRANSACTION],
            key: TRANSACTION_TYPES.FASTER_PAYMENT_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.CHAPS_TRANSACTION],
            key: TRANSACTION_TYPES.CHAPS_TRANSACTION,
        },
        {
            label: TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.IBERBANCO_FEE],
            key: TRANSACTION_TYPES.IBERBANCO_FEE,
        }
    ]

    const accountsArray = accountsList.map((account: any) => ({
        label: account.number === 'ALL' ? 'ALL' : `${account.number} ${account.balance} ${account.currency}`,
        key: account.number,
    }))

    const tableData: Array<any> = sortedTransactions.map((item: ITransaction) => {
        return {
            key: item.transactionNumber,
            date: <div data-time={item.created}><p className={s.dateCellP}>{toHumanDate(item.created).date}</p><p
                className={s.timeCellP}>{toHumanDate(item.created).time}</p></div>,
            transferN: item.transactionNumber,
            payer: item.fromAccount,
            recipient: getRecipientDisplay(item),
            type: item.transactionType,
            amount: <p data-amount={item.amount}
                className={item.direction === 'IN' ? `${s.in}` : `${s.out}`}>{item.direction === 'OUT' && '-'}{item.amount + ' ' + item.currency}</p>,
            status: <>
                <p>
                    {
                        item.transactionStatus === 'Denied' && <p className={s.rejected}>Rejected</p>
                    }
                    {
                        item.transactionStatus === 'New' && <p className={s.pending}>Pending</p>
                    }
                    {
                        item.transactionStatus === 'Approved' && <p className={s.confirmed}>Confirmed</p>
                    }
                </p>
            </>,
            action: (
                <div 
                    className={s.viewButton}
                    onClick={() => showModal(item)}
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            ),
            description: 'test'
        }
    })

    const showModal = (transfer: ITransaction) => {
        setSelectedTransfer(transfer)
        setIsModalOpen(true)
    }

    const generateStatement = (tempData: any) => {
        setStatementLinkIsDisabled(true)
        dispatch(getStatementThunk(token, tempData))
            .then((res) => {
                setStatementLink(res.data)
                const url = process.env.REACT_APP_API_URL + res.data
                window.open(url, '_blank');
                setStatementLinkIsDisabled(false)
            })
            .catch((error) => {
                console.error('Error generating statement:', error);
                setStatementLinkIsDisabled(false)
            })
    }

    const clearFilters = () => {
        setSelectedAccount('ALL')
        setSelectedType(TRANSACTION_TYPES.ALL)
        setDate({
            from: '',
            to: ''
        })
        
        dispatch(setFilters({
            accountNumber: 'ALL',
            from: '',
            to: '',
            selectedType: TRANSACTION_TYPES.ALL,
            purpose: '',
            recipient: '',
            amount: '',
            incoming: false,
            outgoing: false,
            currency: '',
            templateName: '',
            paymentRegion: '',
            period: null
        }))
        
        if (token) {
            const clearedFilters = {
                accountNumber: 'ALL',
                from: '',
                to: '',
                selectedType: TRANSACTION_TYPES.ALL,
                purpose: '',
                recipient: '',
                amount: '',
                incoming: false,
                outgoing: false,
                currency: '',
                templateName: '',
                paymentRegion: '',
                period: null
            }
            dispatch(getTransactionsListThunk(token, clearedFilters))
        }
    }

    return (
        <ConfigProvider
            theme={{
                components: {
                    DatePicker: {
                        colorPrimary: 'var(--primary-color)',
                        fontWeightStrong: 600,
                        colorLink: 'red'
                    }
                },
                token: {
                    colorPrimary: 'var(--primary-color)',
                    colorBorder: '#EEEFEF',
                    fontFamily: 'Inter',
                },
            }}
        >
            <div className={s.wrapper}>

                <CustomModal 
                    isModalOpen={isModalOpen} 
                    setIsModalOpen={setIsModalOpen}
                    maxWidth="800px"
                    title="Transaction Details"
                >
                    <div className={s.modal_content}>

                        <div className={s.transaction_summary}>
                            <div className={s.transaction_summary_left}>
                                <div className={s.transaction_number}>
                                    {selectedTransfer?.transactionNumber}
                                </div>
                                <div className={s.transaction_type}>
                                    {selectedTransfer?.transactionType}
                                </div>
                            </div>
                            <div className={s.transaction_summary_right}>
                                <div className={classnames(
                                    s.transaction_amount_large,
                                    selectedTransfer?.direction === 'OUT' ? s.outgoing : s.incoming
                                )}>
                                    {selectedTransfer?.direction === 'OUT' && '-'}
                                    {selectedTransfer?.amount} {selectedTransfer?.currency}
                                </div>
                                <div className={classnames(
                                    s.status_badge,
                                    selectedTransfer?.transactionStatus === 'New' && s.pending,
                                    selectedTransfer?.transactionStatus === 'Approved' && s.confirmed,
                                    selectedTransfer?.transactionStatus === 'Denied' && s.rejected
                                )}>
                                    {selectedTransfer?.transactionStatus === 'New' && 'Pending'}
                                    {selectedTransfer?.transactionStatus === 'Approved' && 'Confirmed'}
                                    {selectedTransfer?.transactionStatus === 'Denied' && 'Rejected'}
                                </div>
                            </div>
                        </div>

                        <div className={s.details_section}>
                            <h3 className={s.details_section_title}>Transfer Information</h3>
                            <div className={s.details_grid}>
                                <div className={s.detail_item}>
                                    <div className={s.detail_label}>From Account</div>
                                    <div className={s.detail_value}>
                                        {selectedTransfer?.fromAccount}
                                    </div>
                                </div>
                                <div className={s.detail_item}>
                                    <div className={s.detail_label}>Recipient</div>
                                    <div className={s.detail_value}>
                                        {selectedTransfer ? getRecipientDisplay(selectedTransfer) : 'N/A'}
                                    </div>
                                </div>
                                <div className={s.detail_item}>
                                    <div className={s.detail_label}>Date & Time</div>
                                    <div className={s.detail_value}>
                                        {selectedTransfer && `${toHumanDate(selectedTransfer.created).date} ${toHumanDate(selectedTransfer.created).time}`}
                                    </div>
                                </div>
                                <div className={s.detail_item}>
                                    <div className={s.detail_label}>Payment Region</div>
                                    <div className={s.detail_value}>
                                        {selectedTransfer?.paymentRegion || 'N/A'}
                                    </div>
                                </div>
                                {selectedTransfer?.reference && (
                                    <div className={s.detail_item} style={{ gridColumn: '1 / -1' }}>
                                        <div className={s.detail_label}>Reference</div>
                                        <div className={s.detail_value}>
                                            {selectedTransfer.reference}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {selectedTransfer?.recipientDetails && (
                            <div className={s.details_section}>
                                <h3 className={s.details_section_title}>Bank & Recipient Details</h3>
                                <div className={s.details_grid}>
                                    {selectedTransfer.recipientDetails.recipientsBank && (
                                        <div className={s.detail_item}>
                                            <div className={s.detail_label}>Bank Name</div>
                                            <div className={s.detail_value}>
                                                {selectedTransfer.recipientDetails.recipientsBank}
                                            </div>
                                        </div>
                                    )}
                                    {selectedTransfer.recipientDetails.recipientsBankAddress && (
                                        <div className={s.detail_item}>
                                            <div className={s.detail_label}>Bank Address</div>
                                            <div className={s.detail_value}>
                                                {selectedTransfer.recipientDetails.recipientsBankAddress}
                                            </div>
                                        </div>
                                    )}
                                    {selectedTransfer.recipientDetails.recipientsSwiftBic && (
                                        <div className={s.detail_item}>
                                            <div className={s.detail_label}>Swift/BIC Code</div>
                                            <div className={s.detail_value}>
                                                {selectedTransfer.recipientDetails.recipientsSwiftBic}
                                            </div>
                                        </div>
                                    )}
                                    {selectedTransfer.recipientDetails.recipientsAccountNumber && (
                                        <div className={s.detail_item}>
                                            <div className={s.detail_label}>Account Number/IBAN</div>
                                            <div className={s.detail_value}>
                                                {selectedTransfer.recipientDetails.recipientsAccountNumber}
                                            </div>
                                        </div>
                                    )}
                                    {selectedTransfer.recipientDetails.recipientsAddress && (
                                        <div className={s.detail_item}>
                                            <div className={s.detail_label}>Beneficiary Address</div>
                                            <div className={s.detail_value}>
                                                {selectedTransfer.recipientDetails.recipientsAddress}
                                            </div>
                                        </div>
                                    )}
                                    {selectedTransfer.recipientDetails.recipientsEmail && (
                                        <div className={s.detail_item}>
                                            <div className={s.detail_label}>Email</div>
                                            <div className={s.detail_value}>
                                                {selectedTransfer.recipientDetails.recipientsEmail}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        <div className={s.modal_footer}>
                            <TransparentButton
                                icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                title={"Close"}
                                onClick={() => setIsModalOpen(false)}
                            />
                        </div>
                    </div>
                </CustomModal>

                <Formik
                                            initialValues={{
                            from: '',
                            to: '',
                        }}
                    onSubmit={(values) => {
                        const filtersData = {
                            accountNumber: selectedAccount,
                            from: date.from || '',
                            to: date.to || '',
                            selectedType: selectedType,
                            purpose: '',
                            recipient: '',
                            amount: '',
                            incoming: false,
                            outgoing: false,
                            currency: '',
                            templateName: '',
                            paymentRegion: '',
                            period: null
                        }
                        
                        dispatch(setFilters(filtersData))
                        
                        if (token) {
                            dispatch(getTransactionsListThunk(token, filtersData))
                        }

                    }}
                >
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit
                      }) => (
                        <form className={s.form} onSubmit={handleSubmit}>
                            <div className={s.filters_block}>
                                <div className={s.filters_row}>
                                    <div className={s.account_dropdown_block}>
                                        <p className={s.labelText}>Payer account</p>
                                        <Dropdown
                                            menu={{items: accountsArray, onClick: handleAccountPicker}}
                                            placement={"bottom"}
                                            trigger={['click']}
                                            dropdownRender={(menu: React.ReactNode) => (
                                                <div style={contentStyle}>
                                                    {React.cloneElement(menu as React.ReactElement, {style: menuStyle})}
                                                </div>
                                            )}>
                                            <Space style={dropdownStyle}>
                                                <p className={s.account}>{getSelectedAccountDisplay()}</p>
                                                <img src={arrow} alt=""/>
                                            </Space>
                                        </Dropdown>
                                    </div>
                                    <div className={s.transfer_type_block}>
                                        <p className={s.labelText}>transfer type</p>
                                        <Dropdown
                                            menu={{items: transactionTypesArray, onClick: handleTypePicker}}
                                            placement={"bottom"}
                                            trigger={['click']}
                                            dropdownRender={(menu: React.ReactNode) => (
                                                <div style={contentStyle}>
                                                    {React.cloneElement(menu as React.ReactElement, {style: menuStyle})}
                                                </div>
                                            )}>
                                            <Space style={dropdownStyle}>
                                                <p className={s.account}>
                                                    {selectedType === TRANSACTION_TYPES.ALL 
                                                        ? TRANSACTION_TYPE_LABELS[TRANSACTION_TYPES.ALL]
                                                        : TRANSACTION_TYPE_LABELS[selectedType as keyof typeof TRANSACTION_TYPE_LABELS] || selectedType
                                                    }
                                                </p>
                                                <img src={arrow} alt=""/>
                                            </Space>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className={s.filters_row}>
                                    <div className={s.date_picker_block}>
                                        <p className={s.labelText}>date from</p>
                                        <DatePicker suffixIcon={null} style={dateStyle}
                                                    placeholder="Select date from"
                                                    value={date.from ? dayjs(date.from) : null}
                                                    onChange={(_, dateString) => {
                                                        setDate({...date, from: dateString || ''})
                                                    }}
                                                    format={dateFormat}/>
                                    </div>
                                    <div className={s.date_picker_block}>
                                        <p className={s.labelText}>date TO</p>
                                        <DatePicker suffixIcon={null} style={dateStyle}
                                                    placeholder="Select date to"
                                                    value={date.to ? dayjs(date.to) : null}
                                                    format={dateFormat}
                                                    onChange={(_, dateString) => {
                                                        setDate({...date, to: dateString || ''})
                                                    }}
                                        />
                                    </div>
                                    <div className={s.button_wrapper}>
                                        <TransparentButton
                                            large
                                            type={'submit'}
                                            title={"Show"} style={{height: "52px"}}/>
                                        <TransparentButton
                                            large
                                            type={'button'}
                                            title={"Clear Filters"} 
                                            style={{height: "52px"}}
                                            onClick={clearFilters}/>
                                    </div>
                                </div>
                            </div>

                            <div className={s.statement_wrapper}>
                                <div className={s.table_top}>
                                    <div className={s.period}>
                                        {date.from && date.to 
                                            ? `From ${date.from} to ${date.to}`
                                            : date.from 
                                                ? `From ${date.from}`
                                                : date.to 
                                                    ? `To ${date.to}`
                                                    : 'All transactions'
                                        }
                                    </div>
                                    <div className={s.flex}>
                                        <div className={statementLinkIsDisabled ? s.disable : s.statement_link}
                                             onClick={() => generateStatement({
                                                 accountNumber: selectedAccount,
                                                 dateFrom: date.from || '',
                                                 dateTo: date.to || '',
                                                 transferType: selectedType === TRANSACTION_TYPES.ALL ? null : Number(selectedType)
                                             })}
                                        >
                                            <div className={s.generate_link}>
                                                Generate a Statement
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <ConfigProvider theme={{
                                    components: {
                                        Pagination: {
                                            colorPrimary: '#FFFFFF',
                                            colorPrimaryHover: '#FFFFFF',
                                            colorBgContainer: 'var(--primary-color)',
                                            colorLink: '#FFFFFF'
                                        },
                                    },
                                }}>
                                    <Table
                                        bordered={false}
                                        style={{marginTop: 48}}
                                        rowClassName={(record, index) => index % 2 !== 0 ? `${s.table_row_dark}` : ''}
                                        className={s.statementTable}
                                        columns={columns}
                                        pagination={{position: ['bottomCenter'], defaultPageSize: 15}}
                                        dataSource={tableData}
                                        scroll={{ x: 'max-content' }}
                                    />
                                </ConfigProvider>
                            </div>

                            <div className={s.statement_wrapper_mobile}>
                                <div className={s.header}>
                                    <div className={s.period}>
                                        {date.from && date.to 
                                            ? `From ${date.from} to ${date.to}`
                                            : date.from 
                                                ? `From ${date.from}`
                                                : date.to 
                                                    ? `To ${date.to}`
                                                    : 'All transactions'
                                        }
                                    </div>



                                    <div className={statementLinkIsDisabled ? s.disable : s.statement_link}
                                         onClick={() => generateStatement({
                                             accountNumber: selectedAccount,
                                             dateFrom: date.from || '',
                                             dateTo: date.to || '',
                                             transferType: selectedType === TRANSACTION_TYPES.ALL ? null : Number(selectedType)
                                         })}>
                                        <div className={s.generate_link}>
                                            Generate a Statement
                                        </div>
                                    </div>
                                </div>

                                <div className={s.statement_mobile_body}>
                                    {
                                        sortedTransactions?.map((transaction: ITransaction, index: number) => {
                                            return (
                                                <div key={index} className={s.transaction}
                                                     onClick={() => showModal(transaction)}>
                                                    <div className={s.row}>
                                                        <div className={s.transaction_info_row}>
                                                            <div className={s.transaction_time}>
                                                                {toHumanDate(transaction.created).time}
                                                            </div>
                                                            <div className={s.transaction_type}>
                                                                {transaction.transactionType}
                                                            </div>
                                                        </div>
                                                        <div className={s.transaction_date_mobile}>
                                                            {toHumanDate(transaction.created).date}
                                                        </div>
                                                    </div>
                                                    <div className={s.row}>
                                                        <div className={s.transaction_recipient}>
                                                            <div className={s.recipient_label}>To:</div>
                                                            <div className={s.recipient_value}>
                                                                {getRecipientDisplay(transaction)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={s.row}>
                                                        <div>
                                                            {
                                                                transaction.transactionStatus === "New" &&
                                                                <div
                                                                    className={classnames(s.status, s.pending)}>
                                                                    pending
                                                                </div>
                                                            }

                                                            {
                                                                transaction.transactionStatus === "Approved" &&
                                                                <div
                                                                    className={classnames(s.status, s.confirmed)}>
                                                                    confirmed
                                                                </div>
                                                            }

                                                            {
                                                                transaction.transactionStatus === "Denied" &&
                                                                <div
                                                                    className={classnames(s.status, s.rejected)}>
                                                                    rejected
                                                                </div>
                                                            }
                                                        </div>
                                                        <div
                                                            className={classnames(s.amount, transaction.transactionStatus === "Denied" && s.disable)}>
                                                            {transaction.direction === 'OUT' && '-'}{transaction.amount} {transaction.currency}
                                                            <img src={arrow_right} alt=""/>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                        </form>)}
                </Formik>



            </div>
        </ConfigProvider>
    )
        ;
};

export default ListOfTransfers;
